// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import OneColumnSvg from '@rsuite/icon-font/lib/layout/OneColumn';
var OneColumn = createSvgIcon({
  as: OneColumnSvg,
  ariaLabel: 'one column',
  category: 'layout',
  displayName: 'OneColumn'
});
export default OneColumn;